import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '../..';

export const getEnvironmentStateSelector = createSelector(
  (state: RootState) => state.environment,
  (state) => state,
);

export const environmentSelectors = {
  environment: getEnvironmentStateSelector,
};
